module.exports = __webpack_public_path__ + "static/media/KegCycles.d365ab2d.svg";